module.exports = __webpack_public_path__ + "static/media/sunCreme (2).26b42158.jpg";